import { useEffect } from 'react';
import { useEditMode } from '../../hooks/useEditMode.js';
import { useGameInstance } from '../../contexts/GameInstanceContext.js';
import type { TilemapTileset } from '../../game/utils/TilesetResolver.js';

/**
 * DecorationPaletteSync - Syncs decoration palette with game scene tilemap data
 * This component listens for tilemap load events and populates the decoration palette
 */
export function DecorationPaletteSync() {
  const { loadDecorationsFromTilesets } = useEditMode();
  const { getGameScene } = useGameInstance();

  useEffect(() => {
    const scene = getGameScene();
    if (!scene) return;

    // Listen for decoration palette load event
    const handleLoadTilesets = (tilesets: TilemapTileset[]) => {
      loadDecorationsFromTilesets(tilesets);
    };

    // Listen for the event from GameScene
    scene.events.on('decorationPalette:loadTilesets', handleLoadTilesets);

    // Check if tilemap is already loaded (in case we mounted after it loaded)
    const tilemapData = scene.cache.json.get('main_island_raw');
    if (tilemapData && tilemapData.tilesets) {
      loadDecorationsFromTilesets(tilemapData.tilesets);
    }

    return () => {
      scene.events.off('decorationPalette:loadTilesets', handleLoadTilesets);
    };
  }, [getGameScene, loadDecorationsFromTilesets]);

  return null; // This component doesn't render anything
}